<div class="d-flex flex-column vh-100">
  <static-hdr></static-hdr>

  <section class="container flex-grow-1">
    <div class="card card-custom h-100">
      <div class="card-body">
        <h1 class="font-weight-bold text-primary mb-8 mt-4">التدريب </h1>
        <div class="h5 line-height-xl text-dark-65">
        <ul>
          <li class="my-1">عقد البرامج التدريبية في مجالات كفاءة الطاقة، لتأهيل مستوى الأداء ورفعه لدى الكوادر الإدارية والفنية.</li>
          <li class="my-1">اعتماد البرامج التدريبية المهنية والجهات المانحة للشهادات المختصة بالتدريب في المجالات المتعلقة بكفاءة الطاقة.</li>
          <li class="my-1">رفع كفاءة منسوبي الجهات الحكومية للالتزام بالصيانة الدورية والوقائية مما يساهم في رفع كفاءة استهلاك الطاقة في المباني الحكومية.</li>
          <li class="my-1">التعريف بالمواصفات الفنية للأجهزة المستخدمة في المباني الحكومية.</li>
        </ul>
      </div>
        <!-- <p class="h5 line-height-xl text-dark-65">
          يهدف المركز السعودي لكفاءة الطاقة لطوير و رفع كفاءة منسوبي الجهات الحكومية في التخطيط للصيانة والالتزام
          بالصيانة الدورية والوقائية مما يساهم في رفع كفاءة استهلاك الطاقة في المباني الحكومية. بالإضافة للتعريف
          بالمواصفات الفنية الصادرة من الهيئة السعودية للمواصفات والمقاييس والجودة للأجهزة المستخدمة في المباني الحكومية
          مثل ( أجهزة التكييف، الإنارة، مواد العزل الحراري .. إلخ ). و حث منسوبي إدارات المشتريات في الأجهزة الحكومية
          بمعايير كفاءة استهلاك الكهرباء عند استبدال أجهزة التكييف والإنارة باستخدام أجهزة تكييف أكثر كفاءة في الطاقة
          وتقنيات الإنارة المرشدة واختيار الأجهزة الأعلى كفاءة في استهلاك الطاقة
        </p> -->
      </div>

      <div class="card-footer d-flex justify-content-between">
        <button type="button" class="btn btn-outline-light btn-lg px-8" [routerLink]="['/home']">
          عودة
        </button>
      </div>

    </div>
  </section>

  <static-ftr></static-ftr>
</div>